import { FormattedMessage } from 'react-intl';

import messages from './InterestOnLoan.messages';
import { MoneyWithDecimals } from '../../../../ui/moneyWithDecimals';
import SummaryRow from '../../../../ui/summaryRow/SummaryRow';

const InterestOnLoan = ({
    totalInterest,
    isLoading
}: {
    totalInterest: number;
    isLoading: boolean;
}) => (
    <SummaryRow isLoading={isLoading}>
        <FormattedMessage {...messages.totalInterest} />
        <span data-testid="early-repayment-interest">
            <MoneyWithDecimals value={totalInterest} />
        </span>
    </SummaryRow>
);

// eslint-disable-next-line import/no-default-export
export default InterestOnLoan;
